// src/components/modals/UserHistoryModal.tsx
import React from 'react';
import { Modal, Stack, Text, DefaultButton, Icon } from '@fluentui/react';

interface UserHistoryModalProps {
  isOpen: boolean;
  onDismiss: () => void;
  user: any; // Можно заменить на ваш тип User, если он экспортирован
}

const UserHistoryModal: React.FC<UserHistoryModalProps> = ({ isOpen, onDismiss, user }) => {
  if (!user) return null;

  // Форматирование даты для красивого вывода
  const formatDate = (dateString: string) => {
    return new Date(dateString).toLocaleString('ru-RU', {
      day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit'
    });
  };

  return (
    <Modal
      isOpen={isOpen}
      onDismiss={onDismiss}
      isBlocking={false}
      styles={{
        main: { width: 600, maxWidth: '90vw', padding: 24, borderRadius: 8 },
      }}
    >
      <Stack tokens={{ childrenGap: 16 }}>
        <Stack horizontal horizontalAlign="space-between" verticalAlign="center">
          <Text variant="xLarge" style={{ fontWeight: 600 }}>
            История: {user.username}
          </Text>
          <DefaultButton iconProps={{ iconName: 'Cancel' }} onClick={onDismiss} text="Закрыть" />
        </Stack>

        {/* Секция истории входов */}
        <Stack tokens={{ childrenGap: 8 }}>
          <Text variant="large" style={{ fontWeight: 600, borderBottom: '1px solid #edebe9', paddingBottom: 4 }}>
            <Icon iconName="History" style={{ marginRight: 8, color: '#0078d4' }} />
            Последние входы ({user.loginHistory?.length || 0})
          </Text>
          <Stack tokens={{ childrenGap: 4 }} style={{ maxHeight: 200, overflowY: 'auto' }}>
            {user.loginHistory && user.loginHistory.length > 0 ? (
              user.loginHistory.map((login: any, idx: number) => (
                <Stack key={idx} horizontal tokens={{ childrenGap: 16 }} styles={{ root: { fontSize: 13, padding: '4px 8px', background: '#f3f2f1', borderRadius: 4 } }}>
                  <Text style={{ minWidth: 140, fontWeight: 600 }}>{formatDate(login.date)}</Text>
                  <Text>{login.ip || 'Неизвестный IP'}</Text>
                  <Text style={{ color: '#605e5c', fontStyle: 'italic' }}>{login.userAgent || 'Неизвестное устройство'}</Text>
                </Stack>
                // Примечание: $slice: -100 на бэкенде гарантирует, что массив не будет гигантским
              ))
            ) : (
              <Text style={{ color: '#605e5c', fontStyle: 'italic' }}>История входов пуста</Text>
            )}
          </Stack>
        </Stack>

        {/* Секция истории подписок */}
        <Stack tokens={{ childrenGap: 8 }}>
          <Text variant="large" style={{ fontWeight: 600, borderBottom: '1px solid #edebe9', paddingBottom: 4 }}>
            <Icon iconName="Calendar" style={{ marginRight: 8, color: '#107c10' }} />
            История доступа ({user.subscriptionHistory?.length || 0})
          </Text>
          <Stack tokens={{ childrenGap: 4 }} style={{ maxHeight: 200, overflowY: 'auto' }}>
            {user.subscriptionHistory && user.subscriptionHistory.length > 0 ? (
              user.subscriptionHistory.map((sub: any, idx: number) => (
                <Stack key={idx} tokens={{ childrenGap: 4 }} styles={{ root: { padding: '8px 12px', background: '#f3f2f1', borderRadius: 4 } }}>
                  <Stack horizontal tokens={{ childrenGap: 8 }}>
                    <Text style={{ fontWeight: 600 }}>С:</Text>
                    <Text>{formatDate(sub.startDate)}</Text>
                    <Text style={{ fontWeight: 600 }}>По:</Text>
                    <Text>{formatDate(sub.endDate)}</Text>
                  </Stack>
                  {sub.reason && (
                    <Text style={{ fontSize: 12, color: '#323130' }}>
                      <strong>Причина:</strong> {sub.reason}
                    </Text>
                  )}
                {sub.grantedByUsername && (
                <Text style={{ fontSize: 12, color: '#0078d4' }}>
                  Выдал: <strong>{sub.grantedByUsername}</strong>
                  {sub.grantedByEmail && <span style={{ color: '#605e5c' }}> ({sub.grantedByEmail})</span>}
                </Text>
              )}
                </Stack>
              ))
            ) : (
              <Text style={{ color: '#605e5c', fontStyle: 'italic' }}>История подписок пуста</Text>
            )}
          </Stack>
        </Stack>
      </Stack>
    </Modal>
  );
};

export default UserHistoryModal;